import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Container,
  Grid,
  Typography,
  Paper,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import { useForm, Controller } from "react-hook-form";
import * as Inputs from "../../components/Common/Inputs";
import MobileHidden from "../../components/Common/Hidden/MobileHidden";
import Axios from "axios";
import { useSelector } from "react-redux";
import { RootUrl } from "../../redux/types";
import LayoutContainer from "../../components/LayoutsContainer";
const useStyles = makeStyles((theme) => ({
  root: {
    // position: "relative",
    marginTop: theme.spacing(2),
    display: "flex",
    // alignItems: "center",
    justifyContent: "center",
    // // backgroundColor: theme.palette.primary.light,
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(0),
      // backgroundColor: "red",
    },
  },

  gridContainer: {
    flex: 6,
  },
  searchBtn: {
    height: theme.spacing(7),
    flex: 1,
    borderRadius: 100,
    fontSize: "1.1rem",
    fontWeight: "600",
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(1),
    },
  },
  Container: {
    // height: "30vh",

    // zIndex: 99999,
    backgroundColor: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    width: "100%",
    padding: theme.spacing(2),
    borderRadius: 100,
    boxShadow: "0px 5px 10px rgba(0,0,0,0.1)",
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(1),
      flexDirection: "column",
      borderRadius: 20,
    },
    // backgroundColor: theme.palette.primary.dark,
  },
  title: {
    fontSize: 45,
    // color:'white'
    fontWeight: 600,
    textAlign: "center",
    color: theme.palette.secondary.main,
  },
  gridItem: {
    // paddingRight: theme.spacing(2),
    // borderRight: `2px solid #cacaca`,
    [theme.breakpoints.down("md")]: {
      // paddingRight: theme.spacing(0),
      padding: theme.spacing(1),
      // backgroundColor: "red",
      flexDirection: "column",
      borderRight: "none",
    },
    // borderStyle: "solid",
  },
}));

const SearchComponent = ({ data }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [options, setOptions] = React.useState({
    taluka: [],
    gram: [],
  });
  const [values, setValues] = React.useState({
    district: undefined,
    taluka: undefined,
    gram: undefined,
  });
  const language = useSelector((state) => state.util.language);

  const onSubmit = () => {
    if (values.gram) {
      window.open(values.gram);
    }
  };
  const getData = async (name, child) => {
    const response = await Axios.get(
      `${RootUrl}/get${name}/${child}/${language}
      `,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const countries = await response.data?.data;
    setOptions({
      ...options,
      [name]: countries,
    });
  };
  const onChange = (name, value) => {
    const child = data?.data?.find((item) => item.name === name);

    if (child?.dependentChild) {
      setValues({
        ...values,
        [child?.dependentChild]: undefined,
        [child?.dependentOtherChild]: undefined,
        [name]: value,
      });

      getData(child?.dependentChild, value);
    } else {
      setValues({
        ...values,
        [name]: value,
      });
    }
  };

  React.useEffect(() => {
    console.log("values change", values);
  }, [values]);

  const changeOptions = (title, filtered) => {
    setOptions({
      ...options,
      [title]: filtered,
    });
  };

  return (
    <MobileHidden>
      <div className={classes.root}>
        <LayoutContainer>
          <Paper className={classes.Container} elevation={0}>
            <Grid
              container
              alignItems="center"
              justify="space-evenly"
              spacing={isMobile ? 1 : undefined}
              className={classes.gridContainer}
            >
              {data?.data?.map((item, index) => {
                const MyInput = Inputs[item.type];
                item.classes = {
                  select: {
                    backgroundColor: "red",
                  },
                };
                return (
                  <Grid
                    key={index}
                    item
                    lg={3}
                    sm={12}
                    xs={12}
                    md={3}
                    className={classes.gridItem}
                  >
                    <MyInput
                      {...item}
                      onChange={(value) => onChange(item.name, value)}
                      options={item?.options || options[item.name]}
                      value={values[item.name]}
                      changeOptions={(filtered) =>
                        changeOptions(item.name, filtered)
                      }

                      // onChange={(e) => props.onChange(e.target.checked)}
                    />
                  </Grid>
                );
              })}
            </Grid>
            {data && (
              <Button
                fullWidth
                size="large"
                variant="contained"
                color="primary"
                type="submit"
                disableElevation
                className={classes.searchBtn}
                onClick={() => onSubmit()}
              >
                Search
              </Button>
            )}
          </Paper>
          {/* <form onSubmit={handleSubmit(onSubmit)}> */}
          {/* <Container className={classes.container} maxWidth="lg"> */}
          {/* <Grid
            container
            alignItems="center"
            justify="center"
            className={classes.gridContainer}
          >
            <Grid item lg={12}>
              <Typography className={classes.title}>
                તમારું ગ્રામ શોધો
              </Typography>
            </Grid>
            <Grid
              item
              container
              alignItems="center"
              justify="space-between"
              lg={12}
              md={12}
              sm={12}
              xs={12}
            >
              {data?.data?.map((item, index) => {
                const MyInput = Inputs[item.type];
                item.classes = {
                  select: {
                    backgroundColor: "red",
                  },
                };
                return (
                  <Grid item lg={3}>
                    <Controller
                      name={item.name}
                      control={control}
                      defaultValue={undefined}
                      rules={{ required: false }}
                      render={(props) => (
                        <MyInput
                          {...props}
                          {...item}

                          // onChange={(e) => props.onChange(e.target.checked)}
                        />
                      )} // props contains: onChange, onBlur and value
                    />
                  </Grid>
                );
              })}
              <Grid item lg={2}>
                {data && (
                  <Button
                    fullWidth
                    size="large"
                    variant="contained"
                    color="primary"
                    type="submit"
                    disableElevation
                    className={classes.searchBtn}
                  >
                    Search
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid> */}
        </LayoutContainer>
      </div>
    </MobileHidden>
  );
};
export default SearchComponent;
